import React from 'react';

export default class Page extends React.Component {

    render() {
        const { props: { page: { title, url, snippet } } } = this;

        return (
            <li>
                <a href={url} >{title}</a><br/>
                <p>{snippet}</p>        
            </li>
        );
    }

}


